module.exports = __webpack_public_path__ + "static/img/logo_line.f354cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_line.png
// module id = 2Mvs
// module chunks = 39